module.exports = __webpack_public_path__ + "img/mines.a4842c73.webp";